export { default } from '@material-ui/core/MenuItem';

export type MenuItemProps = import('@material-ui/core/MenuItem').MenuItemProps;
